import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import { Storage } from '@/enums/storage.enum';
import store from '@/store/store';
import { getDocumentDetails } from '@/utils/document';
import { documentAssessmentRoute } from './details/assessment.route';
import { documentAssessmentSummarryRoute } from './details/assessmentSummary.route';
import { documentAttachmentsRoute } from './details/attachments.route';
import { documentDecisionRoute } from './details/decision.route';
import { documentDocumentationRoute } from './details/documentation.route';
import { documentEditRoute } from './details/edit.route';
import { documentEditGeneratedRoute } from './details/editGenerated.route';
import { EditViewHtmlRoute } from './details/editViewHtml.route';
import { epuapRoute } from './details/epuap.route';
import { documentErrorsRoute } from './details/errors.route';
import { documentGenerateRoute } from './details/generate.route';
import { documentGenerateSpecificRoute } from './details/generateSpecific.route';
import { documentHistoryRoute } from './details/history.route';
import { documentInvoicesRoute } from './details/invoices.route';
import { documentSystemNumbersRoute } from './details/systemNumbers.route';
import { documentValuesRoute } from './details/values.route';
import { documentViewRoute } from './details/view.route';

export const documentDetailsRoute: RouteConfig = {
  name: 'documentDetails',
  path: ':documentId',
  component: () => import(/* webpackChunkName: "DocumentDetails" */ '@/views/mainRoute/document/Details.vue'),
  meta: { breadcrumb: { title: 'Szczegóły wniosku', name: 'documentView' } },
  children: [
    documentViewRoute,
    documentHistoryRoute,
    documentEditRoute,
    documentEditGeneratedRoute,
    documentErrorsRoute,
    documentAssessmentRoute,
    documentAssessmentSummarryRoute,
    documentAttachmentsRoute,
    documentDocumentationRoute,
    documentGenerateRoute,
    documentGenerateSpecificRoute,
    documentInvoicesRoute,
    documentDecisionRoute,
    documentSystemNumbersRoute,
    documentValuesRoute,
    EditViewHtmlRoute,
    epuapRoute
  ],
  redirect: { name: 'documentView' },
  beforeEnter: (to, from, next) => {
    localStorage.setItem(Storage.PREVIOUS_FULL_PATH, from.fullPath || '');
    getDocumentDetails(to)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.DOCUMENT_CANNOT_GET }));
  }
};
